import { Box, Field, Link } from '@chakra-ui/react';
import { Controller, useFormContext } from 'react-hook-form';
import colors from 'src/theme/colors';
import FieldErrorMessage from 'src/components/input/FieldErrorMessage';
import { Checkbox } from 'src/components/ui/checkbox';
import { FormValues } from '../form/FormValues';

export default function ConsentCheckboxGroup() {
  const {
    control,
    formState: { errors },
  } = useFormContext<FormValues>();

  return (
    <Box>
      <Controller
        control={control}
        name="acceptTerms"
        render={({ field: { onChange, value } }) => (
          <Field.Root mb="6px" id="acceptTerms" invalid={!!errors.acceptTerms}>
            <Checkbox
              invalid={!!errors.acceptTerms}
              checked={value}
              onCheckedChange={({ checked }) => onChange(checked)}
              alignItems="flex-start"
            >
              I agree to the&nbsp;
              <Link
                color={colors.podcastShade600}
                _hover={{ opacity: 0.8 }}
                href="https://alitu.com/t-cs"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms &amp; Conditions
              </Link>
              &nbsp;and&nbsp;
              <Link
                color={colors.podcastShade600}
                _hover={{ opacity: 0.8 }}
                href="https://alitu.com/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </Link>
              .
            </Checkbox>
            <FieldErrorMessage>{errors.acceptTerms?.message}</FieldErrorMessage>
          </Field.Root>
        )}
      />
      <Controller
        control={control}
        name="emailOptIn"
        render={({ field: { onChange, value } }) => (
          <Field.Root id="emailOptIn" invalid={!!errors.emailOptIn}>
            <Checkbox
              invalid={!!errors.emailOptIn}
              checked={value}
              onCheckedChange={({ checked }) => onChange(checked)}
              mt="6px"
              alignItems="flex-start"
            >
              Opt me into Alitu newsletter full of tips, updates, offers &amp; zero spam.
            </Checkbox>
            <FieldErrorMessage>{errors.emailOptIn?.message}</FieldErrorMessage>
          </Field.Root>
        )}
      />
    </Box>
  );
}
